import { DocumentEntity } from 'serviceWorker/repository/document/entity';
import { DocumentUrlsInDto } from 'shared/dtos/in/document';
import { fetchDocumentUrl } from './fetchDocumentUrl';
import { ConfigData } from 'serviceWorker/db/config';
import { debugLog } from 'shared/logger/debugLog';
import { createUrlFromIssueDocument } from './resolveIssueDocumentUrl';
import { createUrlFromTemplateDocument } from './resolveTemplateDocumentUrl';
import { createUrlFromInspectionDocument } from './resolveInspectionDocumentUrl';
import { DOCUMENT_ERROR_SOURCE } from 'shared/domain/document/documentError';
import { fileKindService } from 'services/fileService/fileKindService';

function createUrlFromDocumentEntity(
  setup: ConfigData,
  document: DocumentEntity
): string {
  const url = `/project/${setup.projectId}`;
  if (document.issueId) {
    return url + createUrlFromIssueDocument(document);
  }
  if (document.inspectionId) {
    return url + createUrlFromInspectionDocument(document);
  }
  if (document.templateId) {
    return url + createUrlFromTemplateDocument(document);
  }

  return url;
}

export interface ResolveDocumentRemoteSourceOptions {
  forceRefresh?: boolean;
}

export function resolveDocumentRemoteSource(
  setup: ConfigData,
  document: DocumentEntity,
  options?: ResolveDocumentRemoteSourceOptions
): Promise<DocumentUrlsInDto> {
  const downloadDataPath = `${setup.api}/v2${createUrlFromDocumentEntity(
    setup,
    document
  )}/document/${document._id}/downloadData`;
  const url = options?.forceRefresh
    ? `${downloadDataPath}?refresh=${Date.now()}`
    : downloadDataPath;

  return fetchDocumentUrl(setup, url, options)
    .catch((e): DocumentUrlsInDto => {
      debugLog(`fetchDocumentUrl error`, e);
      return {
        signedRequest: DOCUMENT_ERROR_SOURCE,
        mergedSignedRequest: DOCUMENT_ERROR_SOURCE,
        drawingSignedRequest: DOCUMENT_ERROR_SOURCE,
        mergedThumbnailSignedRequest: DOCUMENT_ERROR_SOURCE,
      };
    })
    .then((resolved) => {
      const normalized = { ...resolved } as DocumentUrlsInDto;
      const isConvertedPdf =
        fileKindService.isPdf(document) &&
        Boolean(normalized.imageSignedRequest);

      if (document.data?.isDrawn && normalized.signedRequest) {
        if (
          isConvertedPdf &&
          normalized.drawingSignedRequest &&
          (!normalized.mergedSignedRequest ||
            normalized.mergedSignedRequest === normalized.imageSignedRequest ||
            normalized.mergedSignedRequest === normalized.signedRequest)
        ) {
          normalized.mergedSignedRequest = normalized.drawingSignedRequest;
        }

        if (!normalized.mergedSignedRequest) {
          normalized.mergedSignedRequest =
            normalized.drawingSignedRequest ||
            (isConvertedPdf
              ? normalized.imageSignedRequest
              : normalized.signedRequest);
        }

        if (!normalized.mergedThumbnailSignedRequest) {
          normalized.mergedThumbnailSignedRequest =
            normalized.thumbnailSignedRequest ||
            (isConvertedPdf
              ? normalized.drawingSignedRequest ||
                normalized.imageSignedRequest
              : normalized.imageSignedRequest) ||
            normalized.signedRequest;
        }
      }
      debugLog(
        `resolveDocumentSourceUrl ${JSON.stringify(normalized)}`,
        normalized
      );
      return normalized;
    });
}
